package com.eladfinish.bible.contest.di.audio

import com.eladfinish.bible.contest.platform.audio.SoundPlayer
import com.eladfinish.bible.contest.platform.audio.WebSoundPlayer
import org.koin.core.module.Module
import org.koin.dsl.module

internal actual val audioPlatformModule: Module = module {
    single<SoundPlayer> { WebSoundPlayer() }
}
